import ResponsiveImage from '../responsive-image';
import WrappedLink from '../wrapped-link';

const ForEmployers = () => {
  return (
    <>
      <div className="angled-bg-bottom mt-5">
        <div className="container-xl">
          <div className="row align-items-end pb-5">
            <div className="col-sm-5 order-sm-last">
              <ResponsiveImage
                src="/images/home/clapping-for-presentation.jpg"
                alt="College Recruiter"
                className="rounded"
              />
            </div>
            <div className="col-sm-7 py-5">
              <p className="mb-3 fs-5 text-red">
                <strong>For Employers</strong>
              </p>
              <h2 className="mb-4">Our solutions will help you hire the next generation</h2>
              <WrappedLink className="text-btn" href="/employers" passHref>
                Get Your Personalized Solution
              </WrappedLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForEmployers;
